import { Routes } from '@angular/router';
import { CommonLayout } from './layout/common-layout/common-layout';
import { ExamLoadingComponent } from './features/test-series/pages/exam-loading/exam-loading';
import { ExamRecommendationComponent } from './features/test-series/pages/exam-recommendation/exam-recommendation';
import { ExamReviewComponent } from './features/test-series/pages/exam-review/exam-review';
import { ExamSummaryComponent } from './features/test-series/pages/exam-summary/exam-summary';
import { ExaminationSubmittedComponent } from './features/test-series/pages/examination-submitted/examination-submitted';
import { InstructionsComponent } from './features/test-series/pages/instructions/instructions';
import { QuestionPaper } from './features/test-series/pages/question-paper/question-paper';
import { PrivacyPolicyComponent } from './shared/components/privacy-policy/privacy-policy';
import { TermsConditionsComponent } from './shared/components/terms-conditions/terms-conditions';
import { PrivateBrowsingBlockedComponent } from './shared/components/private-browsing-blocked/private-browsing-blocked';
import { mockTestSecurityGuard, privateBrowsingGuard, privateBrowsingOnlyGuard, singleExamTabGuard, examEnvironmentGuard } from './core/security/mock-test-security.guard';
import { authGuard, guestGuard } from './core/guards/auth.guard';
import { examLeaveGuard } from './core/guards/exam-leave.guard';
import { examFlowHistoryGuard } from './core/guards/exam-flow-history.guard';
import { HISTORY_FLOOR_PATH } from './core/navigation/history-floor';

export const routes: Routes = [
    {
        // Entry beneath a tab's first page: "back" onto it shows the dashboard.
        path:HISTORY_FLOOR_PATH,
        pathMatch:'full',
        redirectTo:'dashboard'
    },
    {
        path:'',
        canActivate:[privateBrowsingGuard, guestGuard],
        loadChildren: () => import('./features/auth/auth.routes').then(m => m.AuthRoutes)
    },
    {
        path:'private-browsing-blocked',
        component:PrivateBrowsingBlockedComponent,
        canActivate:[privateBrowsingOnlyGuard]
    },
    {
        path:'test-series/:id/exam-recommendation',
        component:ExamRecommendationComponent,
        canActivate:[examFlowHistoryGuard, privateBrowsingGuard, authGuard, singleExamTabGuard, mockTestSecurityGuard]
    },
    {
        path:'test-series/:id/exam-loading',
        component:ExamLoadingComponent,
        canActivate:[examFlowHistoryGuard, privateBrowsingGuard, authGuard, singleExamTabGuard, examEnvironmentGuard, mockTestSecurityGuard]
    },
    {
        path:'test-series/:id/examination-submitted',
        component:ExaminationSubmittedComponent,
        canActivate:[examFlowHistoryGuard, privateBrowsingGuard, authGuard, mockTestSecurityGuard]
    },
    {
        path:'test-series/:id/exam-summary',
        component:ExamSummaryComponent,
        canActivate:[privateBrowsingGuard, authGuard]
    },
    {
        path:'test-series/:id/review',
        component:ExamReviewComponent,
        canActivate:[privateBrowsingGuard, authGuard]
    },
    {
        path:'test-series/:id/instructions',
        component:InstructionsComponent,
        canActivate:[examFlowHistoryGuard, privateBrowsingGuard, authGuard, singleExamTabGuard, mockTestSecurityGuard]
    },
    {
        path:'test-series/:id/question-paper',
        component:QuestionPaper,
        canActivate:[examFlowHistoryGuard, privateBrowsingGuard, authGuard, singleExamTabGuard, mockTestSecurityGuard],
        canDeactivate:[examLeaveGuard]
    },
    {
        path:'terms-conditions',
        component:TermsConditionsComponent
    },
    {
        path:'privacy-policy',
        component:PrivacyPolicyComponent
    },
    {
        path:'',
        component:CommonLayout,
        canActivate:[privateBrowsingGuard, authGuard],
        children:[
            {
                path:'',
                pathMatch:'full',
                redirectTo:'dashboard'
            },
            {
             path:'dashboard',
             loadChildren:()=>import('../app/features/dashboard/dashboard.routes').then((m)=>m.DASHBORAD_ROUTES)
            },
            {
             path:'test-series',
             loadChildren:()=>import('../app/features/test-series/test-series.routes').then((m)=>m.TESTSERIES_ROUTES)
            }
        ]
    }
];
